import { Component, OnInit } from '@angular/core';
import { Chain } from '../../interfaces/chain';
import { ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { AdminService } from '../../services/admin/admin.service';
import { map, tap } from 'rxjs/operators';
import { AddSpecialComponent } from '../../components/modals/add-special/add-special.component';
import { IRestaurantInfo } from '../../interfaces/restaurant';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AuthService } from '../../services/auth/auth.service';
import { AppsService } from '../../services/apps/apps.service';
import { App } from '../../interfaces/app';
import { Observable } from 'rxjs';

@UntilDestroy()
@Component({
  selector: 'app-apps-page',
  templateUrl: './apps-page.component.html',
  styleUrls: ['./apps-page.component.scss']
})
export class AppsPageComponent implements OnInit {
  public currentChain!: Chain;
  public isEdited = false;
  public allRestaurants: IRestaurantInfo[] = [];
  public allApps$!: Observable<App[]>;
  public isLoading = false;
  public editable = false;
  public allRestaurants$!: Observable<IRestaurantInfo[]>;


  constructor(
    private readonly activateRoute: ActivatedRoute,
    private readonly auth: AuthService,
    private readonly apps: AppsService,
    private readonly adminService: AdminService
  ) { }

  ngOnInit(): void {
    this.getCurrentChain();
    this.getAllRestaurants();
  }

  private getCurrentChain(): void {
    this.activateRoute.parent?.data.pipe(
      untilDestroyed(this),
      map((data) => data.chain),
      tap(chain => {
        this.editable = !this.auth.isViewer(chain);
        this.currentChain = chain;
        this.initData();
      })
    ).subscribe();
  }

  public getAllRestaurants(): void {
    this.allRestaurants$ = this.adminService.getRestaurantsByChainId(this.currentChain.id);
  }

  initData(): void {
    this.allApps$ = this.apps.getChainApps(this.currentChain.id);
  }
}
